// This file provides polyfills for Node.js core modules
// that are needed by xml2js in a browser environment

if (typeof window !== 'undefined') {
  window.process = window.process || {};
  window.process.browser = true;
  window.process.env = window.process.env || {};
  window.process.version = '';
  window.process.versions = { node: false };
}